"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataKeys = void 0;
var DataKeys = {
  OpenSearch: 'open-search',
  CloseSearch: 'close-search',
  PrimaryNav: 'primary-nav',
  Logo: 'logo',
  MobileNavTrigger: 'mobile-nav-trigger',
  SkipLink: 'skip-link',
  BackLink: 'back-link',
  CloseButton: 'close-button',
  UserIcon: 'user-icon',
  IconNav: 'icon-nav',
  SideNavigation: 'side-navigation',
  SecondarySideNavigation: 'secondary-side-navigation',
  TopBar: 'top-bar'
};
exports.DataKeys = DataKeys;
//# sourceMappingURL=constants.js.map